import React, { useState } from 'react';
import MouseLightEffect from './MouseLightEffect';
import { useTrack } from '../analytics/TrackingContext';

function ConsumoVehiculo({ capacidadBateria }) {
  const { trackEvent } = useTrack();
  const [autonomia, setAutonomia] = useState('');
  const [resultado, setResultado] = useState(null);
  const [animarResultado, setAnimarResultado] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showInfo, setShowInfo] = useState(false);

  const calcularConsumo = () => {
    if (!autonomia || parseFloat(autonomia) === 0) {
      setErrorMessage('Por favor, introduce la autonomía homologada.');
      setResultado(null);
      return;
    }
    if (!capacidadBateria || parseFloat(capacidadBateria) <= 0) {
      setErrorMessage('Introduce la capacidad de la batería en el campo superior.');
      setResultado(null);
      return;
    }

    const consumoCalculado = (parseFloat(capacidadBateria) * 100) / parseFloat(autonomia);
    setResultado(consumoCalculado);
    setAnimarResultado(true);
    setErrorMessage('');
    trackEvent('calculation', 'consumo_vehiculo');
  };

  return (
    <MouseLightEffect>
    <div className="section-container">

      <div className="tooltip-wrapper" style={{ position: 'absolute', top: '12px', right: '12px' }}>
        <button
          onClick={() => setShowInfo(true)}
          aria-label="Más información"
          style={{ background: 'transparent', border: '1px solid #ccc', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', fontSize: '1rem', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Kiafontl' }}
        >ℹ</button>
        <span className="tooltip-text tooltip-left">Más información</span>
      </div>

      <h2 style={{ textAlign: 'center', width: '100%' }}>Consumo aproximado del vehículo:</h2>

      {showInfo ? (
        <div className="info-panel">
          <p>Calcula el consumo real de tu vehículo eléctrico. Introduce la autonomía homologada en km (la capacidad de la batería se toma del campo superior). El resultado te indica cuántos kWh consume por cada 100 km recorridos.</p>
          <div className="button">
            <button className="calc" onClick={() => setShowInfo(false)}>← Volver</button>
          </div>
        </div>
      ) : (
        <>
      <div className="input">
        <label htmlFor="autonom_homol_input">Autonomía Homologada (Km):</label>
        <input
          id="autonom_homol_input"
          type="number"
          value={autonomia}
          onChange={(e) => setAutonomia(e.target.value)}
          placeholder="Ej: 400"
          min="0"
        />
      </div>

      <div className="button">
        <button className="calc" onClick={calcularConsumo}>Calcular Consumo</button>
      </div>

      {errorMessage && (
          <div className="error-message" role="alert" aria-live="assertive">
          <p>{errorMessage}</p>
        </div>
      )}

      {resultado !== null && (
          <div className={`res ${animarResultado ? 'resultado-animado' : ''}`} aria-live="polite" aria-atomic="true">
          <p>Consumo aproximado del vehículo:</p>
          <p><strong>{resultado.toFixed(2)} kWh/100Km</strong></p>
          <div className="icon-container">
            <img
              src={`${process.env.PUBLIC_URL}/images/icono-consumo02.png`}
              alt="Icono de Consumo"
              className="icono-consumo"
            />
          </div>
        </div>
      )}
        </>
      )}
    </div>
    </MouseLightEffect>
  );
}

export default ConsumoVehiculo;
